import { render } from "./AlbumSmallBox.vue?vue&type=template&id=46f7f4a7&scoped=true"
import script from "./AlbumSmallBox.vue?vue&type=script&lang=js"
export * from "./AlbumSmallBox.vue?vue&type=script&lang=js"

import "./AlbumSmallBox.vue?vue&type=style&index=0&id=46f7f4a7&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\User\\OneDrive - Universidad Nacional de Colombia\\Documentos\\Desarrollo\\Tempo\\Front\\Tempo-Front\\tempo-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46f7f4a7"]])

export default __exports__